import { MallMainLoader } from "@/router";
import { Helmet } from "react-helmet-async";
import { useLoaderData } from "react-router-dom";
import MallBanner from "./MallBanner";
import ProductList from "./ProductList";
import Footer from "./Footer";
import { CssVarsProvider } from '@mui/joy';
import { Box, CssBaseline, Fab, Fade, useScrollTrigger } from '@mui/material';
import theme from "../theme/defaultTheme";
import Nav from "../Nav";
import HomeContainer from "./HomeContainer";

export default function LazyMallHome() {
    return (
        <>
            <Helmet>
                    {/* {
                        mallInfo ? (
                            <>
                                <title>{shopName}</title>
                                <meta name="og:title" content={'공동구매 플로잉'}></meta>
                                <meta name='description' content={`${mallInfo.description}`}></meta>
                                <meta name='og:description' content={`${mallInfo.description}`}></meta>
                            </>
                        ) : (
                            <>
                                <title>LazyMall SHOP</title>
                                <meta name="og:title" content="LazyMall SHOP"></meta>
                                <meta name='description' content="LazyMall SHOP"></meta>
                                <meta name='og:description' content="LazyMall SHOP"></meta>
                            </>
                        )
                } */}
                <title>플로잉몰</title>
                <meta name="og:title" content="FLOWING SHOP"></meta>
                <meta name='description' content="FLOWING SHOP"></meta>
                <meta name='og:description' content="FLOWING SHOP"></meta>
            </Helmet>
            <HomeContainer>
                <MallBanner />
                <ProductList />
                <Footer />
            </HomeContainer>
        </>
    )
}
